// Diálogo global de aviso/confirmación. Reemplaza los ~8 modal-alerta que estaban
// copiados y pegados en cada pantalla (mismo HTML + ~90 líneas de CSS repetido).
//
// Se monta UNA sola vez (ConfirmDialog.vue en App.vue) y todas las pantallas lo
// disparan desde acá. El estado es un singleton a nivel de módulo: todos los
// `useDialog()` comparten el mismo objeto reactivo.
//
// Uso:
//   const { alerta, exito, confirmar } = useDialog();
//   alerta("Falta el nombre.");                       // aviso (rojo), 1 botón
//   exito("Cambios guardados.");                       // éxito (verde), 1 botón
//   confirmar("¿Eliminar?", () => borrar(), { textoBoton: "Sí, eliminar", peligro: true });
import { reactive } from "vue";

const estado = reactive({
  mostrar: false,
  tipo: "error",     // 'error' | 'success' | 'confirm'
  mensaje: "",
  textoBoton: "",    // texto del botón confirmar/aceptar (si vacío, se deriva del tipo)
  peligro: false,    // botón de confirmar en rojo (acciones destructivas)
  onConfirm: null,   // callback del botón confirmar (tipo 'confirm')
  onCerrar: null,    // callback al cerrar un aviso (p. ej. cerrar el formulario tras el éxito)
});

// `onCerrar` (opcional): se ejecuta cuando se cierra el aviso. Sirve para casos como
// "mostrar 'Turno guardado' y, al aceptar, cerrar el formulario".
function alerta(mensaje, tipo = "error", onCerrar = null) {
  estado.mostrar = true;
  estado.tipo = tipo === "success" ? "success" : "error";
  estado.mensaje = mensaje;
  estado.textoBoton = "";
  estado.peligro = false;
  estado.onConfirm = null;
  estado.onCerrar = onCerrar;
}

function exito(mensaje, onCerrar = null) {
  alerta(mensaje, "success", onCerrar);
}

function confirmar(mensaje, onConfirm, { textoBoton = "", peligro = false } = {}) {
  estado.mostrar = true;
  estado.tipo = "confirm";
  estado.mensaje = mensaje;
  estado.textoBoton = textoBoton;
  estado.peligro = peligro;
  estado.onConfirm = onConfirm;
  estado.onCerrar = null;
}

function cerrar() {
  const cb = estado.onCerrar;
  estado.mostrar = false;
  estado.onConfirm = null;
  estado.onCerrar = null;
  if (cb) cb();
}

// La usa solo ConfirmDialog.vue al apretar el botón de confirmar.
function _ejecutarConfirm() {
  const cb = estado.onConfirm;
  estado.mostrar = false;
  estado.onConfirm = null;
  estado.onCerrar = null;
  if (cb) cb();
}

export function useDialog() {
  return { estado, alerta, exito, confirmar, cerrar, _ejecutarConfirm };
}
